import { defineComponent } from 'vue';
import { KycTypes } from '@/types/kyc';
import router from '@/router';
import { storeToRefs } from 'pinia';
import { useKycStore } from '@/store/modules/kyc';
import { MIXPANEL_EVENTS, trackEvent } from '@/utils/mixpanel';
export default defineComponent({
    name: 'VerificationFailed',
    setup() {
        const kycStore = useKycStore();
        const { currentStep: kycStep } = storeToRefs(kycStore);
        const retryVerification = () => {
            trackEvent(MIXPANEL_EVENTS.KYC.RETRY_VERIFICATION, {
                screen: 'Home Screen',
            });
            kycStore.resetStore();
            kycStep.value = KycTypes.KycSteps.KYC_1;
            router.push('/kyc');
        };
        const keypress = () => {
            console.log();
        };
        return {
            retryVerification,
            keypress,
        };
    },
});
